import ContactForm from "kinnect-front/FacilityMaintenance/Contacts/ContactForm";
import DefaultLayout from "@/layouts/DefaultLayout";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { FacilityMaintenanceContact } from "kinnect-models";
import { KActionDialog } from "kinnect-general";

export default {
	name: "FacilityMaintenanceContactPage",

	metaInfo() {
		const title = this.editing
			? "Facility Maintenance - View Contact"
			: "Facility Maintenance - Add Contact";

		return { title };
	},

	props: { idContact: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "facility_maintenance_contacts",
		deleteDialogOpen: false,
		contact: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idContact );
		},

		genDeleteDialog() {
			if ( this.editing && this.contact && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete contact" )}
					onConfirm={() => this.contact.delete()}
					redirect={[ "back", { name: "facilityMaintenanceContacts" } ]}
					title="Delete Contact"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the maintenance contact <strong>{this.contact.name}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete",
					tooltip: "Delete this maintenance contact"
				};
			}
		}
	},

	methods: {
		async fetchContact() {
			if ( this.editing ) {
				this.contact = await FacilityMaintenanceContact.findPageModel( this.idContact );
			}
		},

		async fetch() {
			await this.fetchContact();
		}
	},

	render() {
		return <DefaultLayout>
			<ContactForm
				contact={this.contact}
				loading={this.$wait.is( "find contact" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
			></ContactForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
